<template>
  <div class="upDataPrice">
    <!-- 弹层内容 -->
    <div class="addWrap">
      <div class="subTitBox">修改价格</div>

      <!-- conTent -->
      <div class="addConWrap">
        <!-- 列表标题 -->
        <ul class="ListHeader clearfix">
          <li>商品名称</li>
          <li>单价</li>
          <li>小计</li>
          <li>实付款</li>
        </ul>

        <ul class="listGoods clearfix">
          <li class="flex-row ite-c">
            <img :src="$baseUrl + '!service/file/~java/Downloader.get?id=' + orderItem.pic" alt="">
            <div class="infoWrap flex-col jus-b">
              <p class="info-tit">{{orderItem.busi_info}}</p>
              <p class="info-num">数量：{{orderItem.good_count}}</p>
            </div>
          </li>
          <li>{{orderItem.price_calc}}</li>
          <li class="subtotal">{{orderItem.price_calc}}</li>
          <li>
            <check-input
                    type="price"
                    v-model="price_alter"
                    class="inputnum"
                    :value.sync="price_alter"
                    @onChange="onPriceChange"
            ></check-input>
          </li>
        </ul>

        <div class="orderTip">
          <p>商品共<b>{{orderItem.good_count}}</b>个，运费 {{orderItem.price_logistics}}元，合计 <span class="orangeText"><i>{{total_price}}</i></span>
          </p>
        </div>

        <!-- 底部按键 -->
        <div class="botBtn">
          <button @click="handleCancel" class="butStyle whiteBtn cancelBtn">取消</button>
          <button @click="handleConfirm" class="butStyle pinkBtn enterBtn">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import {yuanToCents, centsToYuan} from '@/utils/unitConverter.js';
  import {isValidPriceFormat,} from '@/utils/validator'

  export default {
    name: "send",
    props: {
      orderItem: {
        type: Object,
        required: false
      }
    },
    data() {
      return {
        total_price: 0,
        price_alter: 0
      }
    },
    created() {
      // this.total_price = parseFloat(this.orderItem.price_calc) + parseFloat(this.orderItem.price_logistics);
      this.total_price = this.orderItem.price_real;
      this.price_alter = this.orderItem.price_real;
    },
    methods: {
      onPriceChange(output) {
        console.info(output)
      },
      // 取消事件
      handleCancel() {
        this.$emit('cancel')
      },
      // 确定事件
      handleConfirm() {
        // if(this.price_alter)
        const value = this.price_alter;
        const validPriceFormat = isValidPriceFormat(value);
        if (value && validPriceFormat) {

        } else {
          // this.$notifyError('金额格式有误，格式为[00000000.00]');
          return;
        }
        if (typeof (value) == "string" && value == '') {
          // this.$notifyError('金额格式有误，格式为[00000000.00]');
          return;
        }
        // 把result对象传递上去
        this.$emit('confirm', this.price_alter)
      },
    }
  }
</script>

<style scoped>
  .upDataPrice {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 99;
    background:rgba(0,0,0,0.6);
  }

  .upDataPrice .addWrap {
    position: absolute;
    width: 640px;
    top: 50%;
    left: 50%;
    border: 1px solid #eee;
    /* -webkit-box-shadow: 6px 6px 12px #ccc;
    -moz-box-shadow: 6px 6px 12px #ccc;
    box-shadow: 6px 6px 12px #ccc; */
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    background: #fff;
    /*z-index: 55;*/
  }

  .addConWrap {
    padding: 14px 14px 24px;
  }

  /* 列表标题 */
  .ListHeader {
    background: #7F7F7F;
    color: #fff;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
  }

  .ListHeader li {
    float: left;
    width: 120px;
    height: 28px;
    line-height: 28px;
  }

  .ListHeader li:nth-child(1) {
    width: 252px;
    text-align: left;
    text-indent: 12px;
  }

  .listGoods {
    border-bottom: 1px solid #eee;
  }

  .listGoods li {
    float: left;
    height: 72px;
    background: #fff;
  }

  .listGoods li:nth-child(1) {
    width: 252px;
  }

  .listGoods li:nth-child(1) img {
    width: 56px;
    height: 56px;
    margin-left: 12px;
  }

  .listGoods li + li {
    width: 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 12px;
    color: #3B3B3B;
  }

  .listGoods li.subtotal {
    font-weight: bold;
    font-size: 12px;
  }

  .listGoods li.shouldPay {
    font-weight: bold;
    font-size: 13px;
    color: #FA6241;
  }

  .infoWrap {
    width: 157px;
    margin-left: 10px;
    height: 56px;
    font-size: 12px;
    color: #B7B2AF;
  }

  .infoWrap .info-tit {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    /* autoprefixer: off */
    -webkit-box-orient: vertical; /* autoprefixer: on */
    font-size: 12px;
    /*height: 30px;*/
    color: #3B3B3B;
    /*margin-bottom: 10px;*/
  }

  /* 订单提示 */
  .orderTip {
    margin-top: 15px;
    text-align: right;
    font-size: 12px;
    color: #3B3B3B;
  }

  .orderTip p span {
    margin-left: 6px;
  }

  .orderTip p span i {
    font-style: normal;
    font-size: 16px;
  }

  /* 底部按键 */
  .botBtn {
    margin-top: 20px;
  }

  .botBtn .enterBtn {
    margin-left: 14px;
  }

  .inputnum {
    width: 72px;
  }
</style>
